import React from 'react'

import LinearProgress from '@material/react-linear-progress'

import '@/presentation/components/ScreenLoading/styles.css'

const ScreenLoading: React.FC = () => (
  <div className="absolute left-0 top-0 block h-screen w-screen bg-white">
    <LinearProgress
      id="screen-loading"
      className="h-2"
      buffer={1}
      progress={1}
      indeterminate
    />
  </div>
)

export default ScreenLoading
